/* eslint-disable react/jsx-one-expression-per-line */
import { ReactElement } from 'react';

import gridStyle from '@pages/forms/Grid.module.scss';
import styles from './ExtensionStep16.module.scss';

function ExtensionStep16(): ReactElement {
  return (
    <>
      <div className={gridStyle.form}>
        <div className="vfH2">You need to call us</div>
        <div className="subHeadingH3">We process applications for payment extensions by companies over the phone.</div>
        <p className={styles.numberSize}>
          Call Fines Victoria: <a href="tel:+61392008111">(03) 9200 8111</a> or <a href="tel:1300369819">1300 369 819</a> (for regional callers)
        </p>
        <p>We're available Monday to Friday, 8am to 6pm (except public holidays).</p>
      </div>
    </>
  );
}

export default ExtensionStep16;
